import request from '@/utils/request'

request.defaults.timeout = 600000;

//modifica date da-a
export function subtractMonthsToDate(date, months) {
   let new_date = new Date(date);
   new_date.setMonth(new_date.getMonth() - months);
   return new_date;
}
//modifica date da-a


export function getList (entity, filters = {}, pagination = {}, select = []) {
  //issue 229
  if (entity === 'protocol_has_site')
  {
    if (pagination.sortBy === 'site_id')
    {
      pagination.sortBy = 'site.factor_label'
    }
  }
  //issue 229
  //issue 228
  if (entity === 'site')
  {
    if (pagination.sortBy === 'country')
    {
      pagination.sortBy = 'country.name'
    }
  }
  //issue 228
  //console.log('------------>' , pagination.sortBy, entity)

  //ISSUE 178
  for( var x in filters)
  {
    if (x === 'section')
    {
      if (filters[x].toLowerCase() === '%users%')
      {
        filters[x] = '%user%'
      }
    }
  }
  //ISSUE 178
  
  //modifica date da-a
  for(var t in filters)
  {
    if (t.indexOf("_$$$_from") > -1)
    {
      var oldval1 = filters[t]
      filters[t] = {}
      filters[t][t.split('_$$$_from')[0]] = '>='+ oldval1
    }
    if (t.indexOf("_$$$_to") > -1)
    {
      var oldval2 = filters[t]
      filters[t] = {}
      filters[t][t.split('_$$$_to')[0]] = '<='+ oldval2
    }
  }
  //modifica date da-a

  return request({
    url: '/' + entity,
    method: 'get',
    headers: {
      'x-filters': JSON.stringify(filters),
      'x-pagination': JSON.stringify(pagination),
      'x-select': JSON.stringify(select),
    }
  }).then( ret => { ret.data = ret.data.map( el => { el._exists = true; return el} ); return ret } )
}

//modifica date da-a
//non usata
/*
export function getCount (entity, filters = {}) {
  return request({
    url: '/' + entity,
    method: 'get',
    headers: {
      'x-filters': JSON.stringify(filters),
      'x-pagination': JSON.stringify({ rowsPerPage: 1 })
    }
  }).then(ret => ret.tot)
}
*/
//modifica date da-a

export function getDetail (entity, entity_id, headers) {
  return request({
    url: '/' + entity + '/' + entity_id,
    method: 'get',
    headers
  }).then( ret => { ret._exists = true; ret._entity_id = entity_id; return ret })
}

export function get (url, headers = {}) {
  return request({
    url,
    method: 'get',
    headers
  })
}

export function post (url, data) {
  return request({
    url,
    method: 'post',
    data
  })
}

export function put (entity, id, data) {
  const method = 'put'
  const url = '/' + entity + '/' + id
  return request({
    url,
    method,
    data
  })
}

export function upsert (entity, data) {
  request.defaults.timeout = 120000;
  let method = 'post'
  let url = '/' + entity

  if (data._entity_id) {
    method = 'put'
    url = '/' + entity + '/' + data._entity_id
  }
  //issue vari miletto
  else if (data.id) 
  {
    method = 'put'
    url = '/' + entity + '/' + data.id
  }
  //issue vari miletto
  return request({
    url,
    method,
    data
  })
}

export function remove (entity, item) {
  return request({
    url: '/' + entity + '/' + item.id,
    method: 'delete'
  })
}
//#ALEXMODI